export const LOCALSTORAGE_KEY_USER = "10A_User"
export const LOCALSTORAGE_KEY_LOCALE = "10A_Locale"
export const LOCALSTORAGE_KEY_PREFS = "10A_Prefs"

export const graphqlEndpoint = process.env.GATSBY_GRAPHQL_ENDPOINT
